import React from 'react';

/**
 * A time-of-day picker that follows the app's theme. Board #400.
 *
 * WHY NOT <input type="time">. Its popup is drawn by the browser, and the only styling hint it
 * takes is `color-scheme`. That was set (b44717ecf) and a live check on Edge confirmed
 * `color-scheme: dark` on the page, the body AND the input — and the popup still opened white,
 * three bounces in a row. No CSS reaches it. A <select>'s popup does honour the scheme plus
 * themed option rows (the pairing CompanyBasicsStep and the Price Book datalist fix use), so the
 * business-hours pickers use one of these instead.
 *
 * Value in and out is 'HH:MM' (24h), the shape business_hours stores. A value with seconds
 * ('05:00:00', the legacy time columns) is matched on its first five characters, and a value
 * off the 15-minute grid is kept as an extra option rather than silently snapped.
 */

const STEP_MINUTES = 15;

const label12h = (hhmm) => {
  const [h, m] = hhmm.split(':').map(Number);
  const suffix = h < 12 ? 'AM' : 'PM';
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour}:${String(m).padStart(2, '0')} ${suffix}`;
};

const GRID = Array.from({ length: (24 * 60) / STEP_MINUTES }, (_, i) => {
  const minutes = i * STEP_MINUTES;
  return `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
});

const optionClass = 'bg-white text-gray-900 dark:bg-slate-800 dark:text-gray-100';

const TimeSelect = ({ value, onChange, className = '', ...rest }) => {
  const current = typeof value === 'string' ? value.slice(0, 5) : '';
  const options = current && !GRID.includes(current) ? [...GRID, current].sort() : GRID;

  return (
    <select
      value={current}
      onChange={(e) => onChange(e.target.value)}
      className={`[color-scheme:light] dark:[color-scheme:dark] ${className}`}
      {...rest}
    >
      {!current && <option className={optionClass} value="">Select a time</option>}
      {options.map((t) => (
        <option key={t} value={t} className={optionClass}>{label12h(t)}</option>
      ))}
    </select>
  );
};

export default TimeSelect;
